'use client'
import { useCallback, useState } from 'react'
import { Box, Button, Flex, Image, Link, Text } from '@chakra-ui/react'
import Calendar from '../modals/calendar'
import { useSearchParams } from 'next/navigation'

const EarningRequirement = () => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false)
  const searchParams = useSearchParams()

  const handleCalendarOpen = () => {
    setIsCalendarOpen(true)
  }

  const createQueryString = useCallback(
    (name: string, value: string) => {
      const params = new URLSearchParams(searchParams.toString())
      params.set(name, value)

      return params.toString()
    },
    [searchParams]
  )

  return (
    <>
      <Calendar
        isOpen={isCalendarOpen}
        onClose={() => setIsCalendarOpen(false)}
      />
      <Box className="my-6 rounded-2xl border-2 border-[#DDDDDD]">
        <div className="h-4 w-full rounded-t-2xl bg-[#ED837F]"></div>

        <Flex className="flex-col gap-5 px-[18px] pt-[18px]">
          <Flex className="flex-col">
            <Image
              src={'/rewards/Calendar.svg'}
              alt="Icon"
              w={8}
              h={8}
              mb={1}
            />
            <Text className="my-1 text-lg font-semibold text-[#ED837F]">
              Wallet Cycle
            </Text>
            <Text
              lineHeight={'normal'}
              className="text-[15px] font-normal text-[#656565]"
            >
              LYKSTAGE wallet statement closes on the 21st of every month, which
              means one cycle is 22nd of the previous month to the 21st of
              the current month, settle on the 7th of the following month.{' '}
            </Text>
          </Flex>

          <Flex className="flex-col">
            <Image
              src={'/rewards/fingerprint.svg'}
              alt="Icon"
              w={8}
              h={8}
              mb={1}
            />
            <Text className="my-1 text-lg font-semibold text-[#ED837F]">
              {/* Earning Requirement */}
              Watch Time Earnings Requirement
            </Text>
            <Text
              lineHeight={'normal'}
              className="text-[15px] font-normal text-[#656565]"
            >
              You can only earn from your watch time if you are logged in.
            </Text>
          </Flex>

          <Flex className="flex-col">
            <Image src={'/rewards/profile.svg'} alt="Icon" w={7} h={7} mb={1} />
            <Text className="my-1 text-lg font-semibold text-[#ED837F]">
              Withdrawal Verification
            </Text>
            <Text
              lineHeight={'normal'}
              className="text-[15px] font-normal text-[#656565]"
            >
              Identity and profile verification is needed for withdrawal of LYK
              Coins.
            </Text>
          </Flex>

          <Flex className="flex-col">
            <Image
              src={'/rewards/exclamationMark.svg'}
              alt="Icon"
              w={7}
              h={7}
              mb={1}
            />
            <Text className="my-1 text-lg font-semibold text-[#ED837F]">
              {/* Earnings Limitation */}
              Watch Time Earnings Limitation
            </Text>
            <Text
              lineHeight={'normal'}
              className="text-[15px] font-normal text-[#656565]"
            >
              {/* Skipping ads means no earnings - earning is based on ad revenue. */}
              Skipping ads means no Watch Time Earnings - Watch Time Earnings is based on ad revenue.
            </Text>
          </Flex>

          <Button
            className="no- mb-3 w-full"
            py={5}
            bg="#E9E9E9"
            color="#656565"
            _hover={{ opacity: 0.7 }}
            size={{ base: 'sm', sm: 'md' }}
            fontWeight={500}
            textDecoration={'none'}
            onClick={handleCalendarOpen}
          >
            Learn more
          </Button>
        </Flex>

        <Flex className="justify-center">
          <Link
            href={`/faqs?${createQueryString('query', "Why aren't my earnings updating")}`}
            className="mb-5 text-center text-sm font-medium"
            textDecorationLine={'underline'}
            color={'#24BFA3'}
          >
            Why your earnings aren’t growing?
          </Link>
        </Flex>
      </Box>
    </>
  )
}

export default EarningRequirement
